import { GamingLimitDataType } from "@data-types/membership/registration";
import { httpClient} from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

class TwGamingLimitsApiService {
	static baseUrl(context: ApiRequestContextData) {
		return `${WEBPACK_BASE_ADDRESS}${context.agencyKey}/tw-gaming-limits`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findGamingLimits(
		options?: ContextOptions
	): Promise<GamingLimitDataType> {
		const context = getApiRequestContext(options);
		const response = await httpClient.get(
			`${this.baseUrl(context)}/compile-default`,
			this.getRequestHeaders(context)
		);

		return response;
	}
}

export default TwGamingLimitsApiService;
